import PropTypes from 'prop-types'
import React, {Fragment, useEffect, useState} from 'react'

import Throbber from './Throbber'

const ImageLoader = ({alt, className, onLoad, role, src}) => {
  const [imageHasLoaded, setImageHasLoaded] = useState(false)

  useEffect(() => {
    setImageHasLoaded(false)
  }, [src])

  return (
    <Fragment>
      <img
        alt={alt}
        className={className}
        role={role}
        src={src}
        onLoad={() => {
          if (typeof onLoad === 'function') {
            onLoad()
          }
          setImageHasLoaded(true)
        }}
      />
      {!imageHasLoaded && <Throbber />}
    </Fragment>
  )
}

ImageLoader.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  onLoad: PropTypes.func,
  role: PropTypes.string,
  src: PropTypes.string,
}

export default ImageLoader
